'use client';

import { formatPrice, formatPercent, formatChange, getChangeColor } from '@/lib/terminal-format';
import { Sparkline } from './Sparkline';

interface KpiCardProps {
  label: string;
  price: number;
  change: number;
  changePercent: number;
  sparkline?: number[];
  isLoading?: boolean;
}

export function KpiCard({ label, price, change, changePercent, sparkline, isLoading }: KpiCardProps) {
  if (isLoading) {
    return (
      <div className="bg-[#111827] border border-[#1F2937] p-3">
        <div className="h-3 w-16 mb-2 bg-[#1F2937] animate-pulse rounded" />
        <div className="h-5 w-20 mb-1 bg-[#1F2937] animate-pulse rounded" />
        <div className="h-3 w-24 bg-[#1F2937] animate-pulse rounded" />
      </div>
    );
  }

  return (
    <div className="bg-[#111827] border border-[#1F2937] p-3">
      <div className="text-[10px] text-[#6B7280] uppercase tracking-wider mb-1">{label}</div>
      <div className="font-mono text-base font-semibold tabular-nums text-[#E5E7EB]">
        {formatPrice(price)}
      </div>
      <div className="flex items-center gap-2 mt-1">
        <span className={`font-mono text-xs tabular-nums ${getChangeColor(change)}`}>
          {formatChange(change)}
        </span>
        <span className={`font-mono text-xs tabular-nums ${getChangeColor(changePercent)}`}>
          ({formatPercent(changePercent)})
        </span>
        {sparkline && sparkline.length > 1 && (
          <Sparkline data={sparkline} width={48} height={18} />
        )}
      </div>
    </div>
  );
}
